import http from './http';
import { listResource } from './listResource';
/**
 * Crear un nuevo tipo de membresía
 */
export async function createSubscription(data) {
  const res = await http.post('/subscriptions', data); 
  return res.data?.data ?? res.data;
}